import React, {PropTypes} from 'react';
import './Form.scss';
import NumberHelper from '../../utils/NumberHelper';

const Form = (props) => {
    const submitClasses = ! props.disableCalculateButton ? "ghg-btn ghg-form-submit" : "ghg-btn ghg-form-submit ghg-btn-disabled";
    const error = props.error ? (<div className="ghg-grid-row ghg-error">
        {props.errorMessage}
    </div>) : '';
    return (
        <form className="ghg-form" onSubmit={(e) => {
            e.preventDefault();
            if (props.value !== '') props.onCalculate();
        }}>
            <div className="ghg-grid-row">
                <fieldset className="ghg-fieldset ghg-input-fieldset ghg-grid-col ghg-grid-3">
                    <input
                        type="text"
                        id="input_1"
                        className="ghg-form-field ghg-form-text"
                        value={NumberHelper.addCommas(props.inputValue)}
                        onChange={(e) => props.onChange(e.target.value)}
                    />
                </fieldset>
                <fieldset className="ghg-fieldset ghg-input-fieldset ghg-grid-col ghg-grid-2">
                    <div className="ghg-post-label">kWh/year</div>
                </fieldset>
            </div>
            {error}
            <div className="ghg-grid-row">
                <fieldset className="ghg-fieldset ghg-input-fieldset ghg-grid-col ghg-grid-3">
                    <a
                        href="#"
                        type="submit"
                        className={submitClasses}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.value !== '') props.onCalculate();
                        }}
                    >Calculate</a>
                </fieldset>
            </div>
        </form>
    );
};

Form.PropTypes = {
    input: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Form;



/** WEBPACK FOOTER **
 ** ./src/components/Form/Form.js
 **/